/* @flow */

import { type ParamEntrega } from './types';
import viewSelectEntregadores from './viewSelectEntregadores';
import viewLoggi from './view-loggi';

const getSelectEntregadores = ({
    pedido,
    entregadores,
}: ParamEntrega) => {
    if (!pedido.endereco || pedido.endereco.usuariosId === 0) {
        return '';
    }

    if (pedido.entregador) {
        return '';
    }

    return viewSelectEntregadores(entregadores);
};

const getSelectLoggi = ({
    totalCost,
    totalEta,
}: ParamEntrega) => {
    if (!totalEta || !totalCost) {
        return '';
    }

    return viewLoggi({ totalCost, totalEta });
};

const getHtmlSelecaoEntrega = (options: ParamEntrega) => {
    const entregadores = getSelectEntregadores(options);
    const loggi = getSelectLoggi(options);
    return entregadores + (entregadores && loggi ? '<hr>' : '') + loggi;
};

export default getHtmlSelecaoEntrega;
